<pwj-filters-dialog
  titleId="products-filters-dialog-title"
  (closed)="close()"
  (applied)="applyFilters()"
  (removed)="removeFilters()">
  <pwj-products-filters [layoutVariant]="'dialog'" />
</pwj-filters-dialog>
